<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            slot(name='multiplayer')
            template(v-if='!homework || homework.editable === undefined || (homework && (homework.editable || usersIds))')
                .form__field(v-if="gameMode !== 'course' && params.mode")
                        label.form__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
                        .form__field-body
                            cs-multiselect(
                                :multiple='false',
                                :options='modes',
                                label='label',
                                :show-labels='false',
                                :allow-empty='false',
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseMode')",
                                :value="{label: $i18n.t('trainer')[params.mode], value: params.mode}",
                                @select='selectMode'
                            )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}
                    .form__field-body
                        cs-multiselect(
                            :multiple='false'
                            :options='difficult'
                            :show-labels='false'
                            :allow-empty='false'
                            track-by='name'
                            label='label'
                            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseDifficulty')"
                            v-model='selectedDifficult' @select='difficultHandler'
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_combiningNumOfDigits') }}
                    .form__field-body
                        cs-checkbox(
                            :checked="params.combining"
                            @change.native="combiningHandler"
                            :disabled="combiningDisabled"
                        )
                .form__field.filter-capacities__field(
                    v-if='params.combining && !params.fractions',
                    v-for="combiningDigitCapacity in filteredCombiningDigitCapacities"
                )
                    .form__label
                        | {{ combiningDigitCapacityLabels[combiningDigitCapacity] }}
                    .form__field-body.filter-capacities__field-body
                        cs-checkbox(
                            :checked="combiningDigitCapacities.includes(combiningDigitCapacity)"
                            :disabled="combiningDigitCapacities.length === 2 && combiningDigitCapacities.includes(combiningDigitCapacity)"
                            @change="changeCombiningDigitCapacities(combiningDigitCapacity)"
                        )
                .form__field(v-if="gameMode !== 'course'")
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                    .form__field-body.form-container__select-examples
                        cs-spin-input(
                            :value="params.amountOfExamples",
                            :max="amountOfExamples",
                            :min="1",
                            :disabled="params && (params.infinityAmountOfExamples || !!params.timeLimit)",
                            @increase="increaseExamples",
                            @decrease="decreaseExamples",
                            @input="params.amountOfExamples = $event",
                        )
                        .form-container__select-infinity-mode(v-if="gameMode && gameMode === 'free-game'")
                            cs-checkbox#infinityAmountOfExamples.form-container__checkbox(
                                v-model="params.infinityAmountOfExamples"
                                :checked="params && params.infinityAmountOfExamples"
                                :disabled="params && !!params.timeLimit"
                            )
                            svg-icon.form-container__svg-icon(name="infinity" :aria-hidden="true" size="big")
                .form__field(v-if="gameMode !== 'course'")
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfActions') }}
                    .form__field-body
                        cs-spin-input(
                            :value="params.amountOfActions",
                            :max="amountOfActions",
                            :min="2",
                            @increase="increaseActions",
                            @decrease="decreaseActions",
                            @input="params.amountOfActions = $event",
                        )
                .form__field(v-if="gameMode !== 'course'")
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfUnknowns') }}
                    .form__field-body
                        cs-spin-input(
                            :value="params.amountOfUnknowns",
                            :max="params.amountOfActions - 1",
                            :min="1",
                            @increase="increaseUnknowns",
                            @decrease="decreaseUnknowns",
                            @input="params.amountOfUnknowns = $event",
                        )
                .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
                    .form__field-body
                        cs-multiselect(
                            :options="timeLimitValues",
                            v-model="params.timeLimit"
                            :placeholder="timeLimitLabel(params.timeLimit)"
                            :multiple="false"
                            :custom-label="timeLimitLabel"
                        )
                .form__field.checkbox(v-if="gameMode !== 'course'")
                    label.form__label.checkbox__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_negativeAnswers') }}
                    .form__field-body
                        cs-checkbox(
                            v-model="params.negativeAnswers"
                        )
                template(v-if="gameMode !== 'course'")
                    .form__field.checkbox
                        label.form__label.checkbox__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
                        .form__field-body
                            cs-checkbox(
                                :checked="params.fractions"
                                @change.native="fractionsHandler"
                            )
                    .form__field(v-if='params.fractions')
                        label.form__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
                        .form__field-body
                            cs-select(
                                :options="2"
                                v-model="params.fractionalPart"
                            )
            slot(name='parameters')
            slot(name='help')
            .buttons-container
                template(v-if='!usersIds')
                    cs-button.form__button(type="button", pattern="primary-outline" color="blue" @click='cancel')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                    template(v-if="gameMode && gameMode === 'free-game'")
                        cs-button.form__button(type="button", color="blue" @click='saveGameMode')
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                    template(v-else='')
                        cs-button.form__button(type="button", color="blue" @click='saveGame')
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(type="button", pattern="primary-outline" color="blue" @click='cancel')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                    cs-button.form__button(type="button", color="blue" @click='saveGame')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/

    import _ from 'lodash';
    import {mapState} from 'vuex';
    import TrainerGames from '../../../config/trainer';
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import {getInitParameters} from '../../../utils/trainer/getInitParameters';
    const DEFAULT_TIME_LIMIT = 0;
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';
    import combiningCapacitiesMixin from '../utils/combiningCapacitiesMixin';

    import IntervalConfig from '../../trainer/configs/IntervalConfig';

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex'
        ],
        data() {
            return {
                modes: [
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbacus'),
                        value: 'На счетах'
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_inMind'),
                        value: 'В уме'
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_any'),
                        value: 'Любой'
                    }
                ],
                difficult: [
                    {
                        label: this.$i18n.t('common.common_gameSetting_singleDigitNum'),
                        name: 'Однозначные цифры',
                        $isDisabled: false
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                        name: 'Двузначные цифры',
                        $isDisabled: false
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                        name: 'Трехзначные цифры',
                        $isDisabled: false
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                        name: 'Четырехзначные цифры',
                        $isDisabled: false
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fiveDigitsNum'),
                        name: 'Пятизначные цифры',
                        $isDisabled: false
                    },
                    {
                      label: this.$i18n.t('common.common_gameSetting_sixDigitsNum'),
                      name: 'Шестизначные цифры',
                      $isDisabled: false
                    },
                    {
                      label: this.$i18n.t('common.common_gameSetting_sevenDigitsNum'),
                      name: 'Семизначные цифры',
                      $isDisabled: false
                    },
                    {
                      label: this.$i18n.t('common.common_gameSetting_eightDigitsNum'),
                      name: 'Восьмизначные цифры',
                      $isDisabled: false
                    },
                ],
                amountOfExamples: 100,
                amountOfActions: 10,
                timeLimitValues: IntervalConfig.timeLimitValues,
                params: null,
                selectedDifficult: null
            }
        },
        mixins: [GameFormMixin, multiplayerFormMixin, combiningCapacitiesMixin],
        mounted() {
            if (this.isGeneratorSettings) {
                if (this.homework && this.homework.grades && this.homework.grades.length) {
                    let currentGameSettings = this.homework.grades[0].course.games.find(element => element.slug == this.slug);
                    this.gamesParameters[this.slug] = currentGameSettings.parameters.default;
                }
                if (this.homework && this.homework.courses) {
                    let copyCourses = this.homework.courses.filter(course => course.games.find(element => element.slug == this.slug));
                    copyCourses.sort((a, b) => a.level - b.level);
                    let currentGameSettings = copyCourses[0].games.find(element => element.slug == this.slug);
                    this.gamesParameters[this.slug] = currentGameSettings.parameters.default;
                }
            }

            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: _.cloneDeep(this.gamesParameters[this.slug])
                        }
                    }));
                    let difficultIndex = this.difficult.map(
                        difficulty => difficulty.name
                    ).indexOf(this.gamesParameters[this.slug].difficult);
                    for (let i = difficultIndex + 1; i < this.difficult.length; i++) {
                        this.difficult[i].$isDisabled = true
                    }
                } else {
                    _.cloneDeep(TrainerGames.games).forEach(item => {
                        if (item.slug === this.slug) {
                            this.params = item.parameters.default;
                        }
                    });
                }
                this.selectedDifficult = _.find(this.difficult, {name: this.params.difficult});
                this.params.infinityAmountOfExamples = true;
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
        },
        watch: {
            'params.amountOfExamples'(val) {
                if (val) {
                    this.params.timeLimit = DEFAULT_TIME_LIMIT;
                }
            },
            'params.timeLimit' (val) {
                if (val) {
                    this.params.amountOfExamples = '';
                } else {
                    if (!this.params.amountOfExamples) {
                        this.params.amountOfExamples = 1;
                    }
                }
                if (val === null) {
                    this.params.timeLimit = 0;
                }
            },
            'params.amountOfActions'(val) {
                if (this.params.amountOfUnknowns >= +val) {
                    this.params.amountOfUnknowns = +val - 1;
                }
            },
            combiningDisabled(val) {
                if (val) {
                    this.params.combining = false;
                }
            }
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            }),
            isGeneratorSettings () {
                if (this.gameMode == 'generator-settings' && this.gamesParameters) {
                    return true;
                }
                return false;
            },
            combiningDisabled () {
                return this.params && this.params.difficult === 'Однозначные цифры';
            },
            combiningDigitCapacities () {
                return this.params && this.params.combiningDigitCapacities;
            }
        },
        methods: {
            selectMode (mode) {
                this.params.mode = mode.value;
            },
            difficultHandler(difficult) {
                this.params.difficult = difficult.name;
                if (this.params.combining) {
                    this.fillCombiningDigitCapacities();
                }
                if (this.combiningDisabled) {
                    this.params.combiningDigitCapacities = [];
                }
            },
            combiningHandler(event) {
                let combining = event.target.checked;
                this.params.combining = combining;
                this.params.combiningDigitCapacities = [];
                if (combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            fractionsHandler(event) {
                let value = event.target.checked;
                this.params.fractions = value;
                if (value && this.params.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            timeLimitLabel(amount) {
                return amount === 0 ? this.$i18n.t('trainer.trainer_gameFormSettingValue_off')
                    : amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_minutes')
            },
            decreaseExamples() {
                if (this.params.amountOfExamples !== 1 && !this.params.timeLimit && !this.params.infinityAmountOfExamples) {
                    this.params.amountOfExamples -= 1;
                }
            },
            increaseExamples() {
                if (this.params.amountOfExamples !== this.amountOfExamples && !this.params.timeLimit && !this.params.infinityAmountOfExamples) {
                    this.params.amountOfExamples += 1;
                }
            },
            decreaseActions() {
                if (this.params.amountOfActions !== 2) {
                    this.params.amountOfActions -= 1;
                }
            },
            increaseActions() {
                if (this.params.amountOfActions !== this.amountOfActions) {
                    this.params.amountOfActions += 1;
                }
            },
            decreaseUnknowns() {
                if (this.params.amountOfUnknowns !== 1) {
                    this.params.amountOfUnknowns -= 1;
                }
            },
            increaseUnknowns() {
                if (this.params.amountOfUnknowns !== this.amountOfActions - 1) {
                    this.params.amountOfUnknowns += 1;
                }
            }

        }
    }
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        max-width: 1020px;
        margin: 0 auto;
        box-sizing: border-box;
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }
    .form__field-body {
        flex-grow: 5;
    }

    .form-container__select {
        width: 100%;
        max-width: 220px;
        @media screen and (max-width: 767px) {
            max-width: none;
        }
        @include media($xl) {
            max-width: 280px;
        }
    }

    .form-container__select-examples {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (min-width: 700px) {
            flex-direction: row;
            align-items: center;
        }
    }

    .form-container__select-infinity-mode {
        display: flex;
        align-items: center;
        margin-top: 20px;
        @media screen and (min-width: 700px) {
            margin-top: 0;
        }
    }

    .form-container__checkbox{
        margin-left: 30px;
    }

    .form-container__svg-icon {
        opacity: 0.7;
        margin: 0 10px 10px 0;
    }

    .filter-capacities__field {
        width: 50%;
    }

    .filter-capacities__field-body {
        display: flex;
        flex-wrap: wrap;
        .cs-checkbox {
            margin-right: 20px;
        }
    }

    .buttons-container {
        display: flex;
        justify-content: center;
        margin: 20px;
        flex-direction: column;
        @include media($sm) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .checkbox {
        @media screen and (max-width: 767px) {
            flex-direction: row;
            align-items: center;
            flex-wrap: nowrap;
        }
    }

    .checkbox__label {
        @media screen and (max-width: 767px) {
            margin-bottom: 0;
            display: flex;
            align-items: center;
        }
    }
</style>
